// SidebarAddClientPeople component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'
import FieldTitle from '../../form/field_title/field_title.jsx'
import FieldText from '../../form/field_text/field_text.jsx'

class SidebarAddClientPeople extends Component {
  constructor (props) {
    super(props)

    this._refs = {}
  }

  static get propTypes () {
    return {
      contactPersons: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      contactPersons: [],
      onChange: null
    }
  }

  /* Private Functions */
  _createNewPersonIfNotExists (personIndex) {
    const { contactPersons } = this.props

    // Check index is last record or not
    if (personIndex === contactPersons.length - 1) {
      contactPersons.push({
        name: '',
        email: '',
        phone: ''
      })

      this._onChangePerson()
    }
  }

  _setFocusField (personIndex, name) {
    const refKey = `${personIndex}_${name}`
    if (this._refs[refKey]) {
      this._refs[refKey].focus()
    }
  }

  /* Handler Functions */
  _onChangePerson () {
    const { contactPersons, onChange } = this.props
    if (onChange) {
      onChange('contactPersons', contactPersons)
    }
  }

  _onChangeField (person, personIndex, name, value) {
    person[name] = value

    this._onChangePerson()
  }

  _onKeyDownField (personIndex, name, ev) {
    if (ev.keyCode === 9 || ev.keyCode === 13) {
      ev.preventDefault()

      if (name === 'phone') {
        // If there is no more row, create a new one and after refresh, set the focus
        if (personIndex === this.props.contactPersons.length - 1) {
          this._createNewPersonIfNotExists(personIndex)
          setTimeout(() => {
            this._setFocusField(personIndex + 1, 'name')
          }, 400)
        } else {
          // Move to next row
          this._setFocusField(personIndex + 1, 'name')
        }
      } else {
        this._setFocusField(personIndex, name === 'name' ? 'email' : 'phone')
        this._createNewPersonIfNotExists(personIndex)
      }
    }
  }

  _onDeletePerson (personIndex) {
    const { contactPersons } = this.props
    contactPersons.splice(personIndex, 1)
    this._onChangePerson()
  }

  /* Other Render Functions */
  _renderPerson (person, personIndex) {
    return (
      <div className='person-item'>
        <div className='person-colname'>
          <FieldTitle title='projectV2.sidebarPeople.name' />
          <div className='person-colname-input'>
            <IconButton
              icon='profile'
              iconSize='14'
              className='person-delete'
              canHover
            />
            <FieldText
              ref={(ref) => {
                this._refs[`${personIndex}_name`] = ref
              }}
              name='name'
              value={person.name}
              onChange={this._onChangeField.bind(
                this,
                person,
                personIndex,
                'name'
              )}
              onKeyDown={this._onKeyDownField.bind(this, personIndex, 'name')}
              validations={['required']}
            />
          </div>
        </div>
        <div className='person-colemail'>
          <FieldTitle title='projectV2.sidebarPeople.email' />
          <FieldText
            ref={(ref) => {
              this._refs[`${personIndex}_email`] = ref
            }}
            name='email'
            value={person.email}
            onChange={this._onChangeField.bind(
              this,
              person,
              personIndex,
              'email'
            )}
            onKeyDown={this._onKeyDownField.bind(this, personIndex, 'email')}
            validations={['email']}
          />
        </div>
        <div className='person-colphone'>
          <FieldTitle title='projectV2.sidebarPeople.phone' />
          <div className='person-colphone-input'>
            <IconButton
              icon='edit'
              size='normal'
              className='person-delete'
              canHover
            />
            <FieldText
              ref={(ref) => {
                this._refs[`${personIndex}_phone`] = ref
              }}
              name='phone'
              value={person.phone}
              onChange={this._onChangeField.bind(
                this,
                person,
                personIndex,
                'phone'
              )}
              onKeyDown={this._onKeyDownField.bind(this, personIndex, 'phone')}
              validations={['phone']}
            />
            <div className='person-colaction'>
              <IconButton
                icon='x'
                size='normal'
                className='person-delete'
                canHover
                onClick={this._onDeletePerson.bind(this, personIndex)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  /* Render Functions */
  render () {
    const { contactPersons } = this.props

    return (
      <div className='sidebar-people'>
        <div className='person-title'>
          <FieldTitle title='projectV2.sidebarPeople.contacts' />
        </div>
        <div className='person-list'>
          {contactPersons &&
            contactPersons.map((person, personIndex) =>
              this._renderPerson(person, personIndex)
            )}
        </div>
      </div>
    )
  }
}

export default SidebarAddClientPeople
